// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import deBlog from "./locales/de/blog.json";
import deForum from "./locales/de/forum.json";
import deTranslation from "./locales/de/translation.json";
import enBlog from "./locales/en/blog.json";
import enForum from "./locales/en/forum.json";
import enTranslation from "./locales/en/translation.json";
import esBlog from "./locales/es/blog.json";
import esForum from "./locales/es/forum.json";
import esTranslation from "./locales/es/translation.json";
import frBlog from "./locales/fr/blog.json";
import frForum from "./locales/fr/forum.json";
import frTranslation from "./locales/fr/translation.json";
import itBlog from "./locales/it/blog.json";
import itForum from "./locales/it/forum.json";
import itTranslation from "./locales/it/translation.json";
import ptBlog from "./locales/pt/blog.json";
import ptForum from "./locales/pt/forum.json";
import ptTranslation from "./locales/pt/translation.json";

const supportedLanguages = ["en", "es", "fr", "de", "it", "pt"];
const browserLanguage = navigator.language.split("-")[0]; // Obtener el código del idioma principal (ej: 'es' de 'es-ES')
// Calculado pero no usado: la app fuerza 'es' en init() abajo porque el resto
// de idiomas aún están "Próximamente". Se mantiene para reactivar multi-idioma
// con un solo cambio (sustituir `lng: "es"` por `lng: defaultLanguage`).
// eslint-disable-next-line no-unused-vars
const defaultLanguage = supportedLanguages.includes(browserLanguage)
  ? browserLanguage
  : "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation, blog: enBlog, forum: enForum },
    es: { translation: esTranslation, blog: esBlog, forum: esForum },
    pt: { translation: ptTranslation, blog: ptBlog, forum: ptForum },
    fr: { translation: frTranslation, blog: frBlog, forum: frForum },
    de: { translation: deTranslation, blog: deBlog, forum: deForum },
    it: { translation: itTranslation, blog: itBlog, forum: itForum },
  },
  lng: "es", // Forzado a español: el resto de idiomas están "Próximamente"
  fallbackLng: "es", // Si una clave no existe en el idioma activo, cae a español
  ns: ["translation", "blog", "forum"],
  defaultNS: "translation",
  interpolation: { escapeValue: false },
});

export default i18n;
